import { Wrapper } from './header.styles';

import { VENDOR_BUSINESS_NAME } from '../constants';

import saladStoryIcon from '../static/saladstory-mono.svg';

export default function Header() {
  return (
    <Wrapper>
      <img alt={VENDOR_BUSINESS_NAME} height={79} src={saladStoryIcon} width={233} />
    </Wrapper>
  );
}
